query PurchaseOrderAvailableTags($id: UUID!) {
  purchaseOrderAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
